import { useQuery } from '@apollo/client';

import type { UserJobApplicationCv } from '@xing-com/crate-common-graphql-types';
import { GetUserRecentCvsDocument } from '@xing-com/crate-jobs-graphql';

type UseGetUserRecentCvsReturnValue = {
  isGetUserRecentCvsError: boolean;
  isGetUserRecentCvsLoading: boolean;
  userRecentCvs: UserJobApplicationCv[];
};

export const useGetUserRecentCvs = (
  isLoggedIn: boolean
): UseGetUserRecentCvsReturnValue => {
  const { data, error, loading } = useQuery(GetUserRecentCvsDocument, {
    skip: !isLoggedIn,
    fetchPolicy: 'network-only',
  });

  const userRecentCvs = data?.viewer?.userRecentCvs
    ?.filter(
      (item: UserJobApplicationCv | null): item is UserJobApplicationCv =>
        item !== null
    )
    .sort(
      (a, b) =>
        new Date(b.lastUsedAt).getTime() - new Date(a.lastUsedAt).getTime()
    );

  return {
    isGetUserRecentCvsError: !!error || !data?.viewer?.userRecentCvs,
    isGetUserRecentCvsLoading: loading,
    userRecentCvs: userRecentCvs || [],
  };
};
